import { axiosInstance } from './config/instance'
import { CONSOLE_API_URL, SERVER } from './config/url'

const ENTITY = 'auth/admin/realms/idpay_realm'
const KEYCLOAK_URL = `${SERVER}/${CONSOLE_API_URL}/${ENTITY}`

export const keycloak = Object.freeze({
  async fetchRolesList() {
    return await axiosInstance.get(`${KEYCLOAK_URL}/roles`)
  },
  async fetchUserList() {
    return await axiosInstance.get(`${KEYCLOAK_URL}/users`)
  },
  async fetchUserItem(id) {
    return await axiosInstance.get(`${KEYCLOAK_URL}/users/${id}`)
  },
  async fetchUserRoleMappings(id) {
    return await axiosInstance.get(`${KEYCLOAK_URL}/users/${id}/role-mappings`)
  },
  async createUserRoleMappings(id, data) {
    return await axiosInstance.post(`${KEYCLOAK_URL}/users/${id}/role-mappings/realm`, data)
  },
  async deleteUserRoleMappings(id, data) {
    const response = await axiosInstance.request({
      url: `${KEYCLOAK_URL}/users/${id}/role-mappings/realm`,
      method: 'DELETE',
      data,
    })
    return response.data
  },
  async createUserItem(data) {
    return await axiosInstance.post(`${KEYCLOAK_URL}/users`, data)
  },
  async deleteUserItem(id) {
    return await axiosInstance.delete(`${KEYCLOAK_URL}/users/${id}`)
  },
  async updateUserItem(id, data) {
    return await axiosInstance.put(`${KEYCLOAK_URL}/users/${id}`, data)
  },
  async updatePasswordUserItem(id, data) {
    return await axiosInstance.put(`${KEYCLOAK_URL}/users/${id}/reset-password`, data)
  },
})
